
import React from 'react'
import Icon from 'react-icon-base'

const FaFilter = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m35.8 6.6q0.4 0.9-0.3 1.5l-11 11.1v16.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-5.7-5.7q-0.5-0.4-0.5-1v-10.8l-11-11q-0.7-0.7-0.3-1.6 0.4-0.9 1.3-0.9h28.6q0.9 0 1.3 0.9z"/></g>
    </Icon>
)

export default FaFilter



// WEBPACK FOOTER //
// ./~/react-icons/fa/filter.js